import { EstatusCompra } from "../../constant/catEstatusCompra"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import { Tooltip } from "@material-ui/core"

const EstatusCuenta = (props) => {
    const { estatus } = props
    switch (estatus) {
        case EstatusCompra.NoAplica:
            return <div>N/A</div>
        case EstatusCompra.PAGADO:
            return (
                <Tooltip title="Pagado">
                    <CheckCircleIcon color='secondary' />
                </Tooltip>
            )
        case EstatusCompra.PENDIENTE_AUTORIZACION:
            return (
                <Tooltip title="Pendiente de autorizacion">
                    <LocalAtmIcon style={{ color: "#B89130" }} />
                </Tooltip>
            )
        case EstatusCompra.FONDOS_INSUFICIENTES:
            return (
                <Tooltip title="Fondos insuficientes">
                    <LocalAtmIcon color='error' />
                </Tooltip>
            )
        case EstatusCompra.APROBADO_CLIENTE:
            return (
                <Tooltip title="Aprobado por el cliente">
                    <LocalAtmIcon color='primary' />
                </Tooltip>
            )
        case EstatusCompra.APROBADO_AGENTE:
            return (
                <Tooltip title="Aprobado por el agente">
                    <LocalAtmIcon color='secondary' />
                </Tooltip>
            )
        default:
            return <div>N/A</div>
    }
}
export default EstatusCuenta